/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import DropdownComponent from './DropdownComponent';
import DropdownMultiComponent from './DropdownMultiComponent';
import getAssocsFromSessionStorage from '../helpers/sessionHandler';

class SearchComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: !sessionStorage.getItem('gym-query') ? '' : sessionStorage.getItem('gym-query'),
      assocs: getAssocsFromSessionStorage(),
      active: 0,
      reset: false,
    };

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.setActive = this.setActive.bind(this);
    this.reset = this.reset.bind(this);
    this.typeSearch = debounce(this.typeSearch.bind(this), 300);
    this.dropDownSearch = this.dropDownSearch.bind(this);
  }

  componentDidMount() {
    const { query, assocs } = this.state;
    const { getItems } = this.props;
    if (query !== '' || assocs.length > 0) {
      const a = assocs.join(',');
      getItems(query, a);
      const reset = false;
      this.setState({ query, reset });
    }
  }

  handleKeyUp(e) {
    const query = e.target.value;
    const reset = false;
    this.setState({ query, reset }, () => {
      this.typeSearch();
    });
  }

  setActive(index) {
    this.setState({
      active: index,
    });
  }

  reset(e) {
    const { getItems, setSelectedSubjects } = this.props;
    e.preventDefault();
    getItems('', '');
    setSelectedSubjects([], true);
    this.setState({
      query: '',
      assocs: [],
      active: 0,
      reset: true,
    });
  }

  typeSearch() {
    const { assocs, query } = this.state;
    const { getItems } = this.props;
    const a = assocs.join(',');
    getItems(query, a);
  }

  dropDownSearch(assoc, clear) {
    const { assocs, query } = this.state;
    const { getItems } = this.props;

    clear.forEach((c) => {
      const cIdx = assocs.indexOf(c);
      if (cIdx > -1) {
        assocs.splice(cIdx, 1);
      }
    });

    // Efter tilføjelse af anvend-knap skal vi tjekke,
    // om det er et array af flere assocs, der skal aktiveres
    if (Array.isArray(assoc)) {
      assoc.forEach((a) => {
        const index = assocs.indexOf(a);
        if (index < 0) {
          assocs.push(a);
        }
      });
    } else {
      const index = assocs.indexOf(assoc);
      if (index > -1) {
        assocs.splice(index, 1);
      }
      if (assoc > 0) {
        assocs.push(assoc);
      }
    }

    getItems(query, assocs.join(','));
    const reset = false;
    this.setState({ assocs, reset });
  }

  render() {
    const {
      groupings,
      setSelectedSubjects,
      items,
    } = this.props;
    const {
      active,
      reset,
      query,
      assocs,
    } = this.state;
    const ddNodes = groupings.map((group, i) => {
      const key = i;
      if (i < 3) { // Type, emne, sted
        if (group.AssociationContainers.length > 0) {
          return (
            <div key={key} className="column large-4 medium-4 small-12">
              <div>
                <DropdownMultiComponent
                  index={(key + 1)}
                  active={active}
                  grouping={group}
                  dropDownSearch={this.dropDownSearch}
                  setActive={this.setActive}
                  reset={reset}
                  setSelectedSubjects={setSelectedSubjects}
                />
              </div>
            </div>
          );
        }
        return (
          <div key={key} className="column large-4 medium-4 small-12">
            <div>
              <DropdownComponent
                index={(i + 1)}
                active={active}
                grouping={group}
                dropDownSearch={this.dropDownSearch}
                setActive={this.setActive}
                reset={reset}
              />
            </div>
          </div>
        );
      }
      return null;
    });

    return (
      <div className="row">
        <div className="column large-12 medium-12 small-12">
          <div className="gym-search">
            <div className="row">
              <div className="column large-8 medium-8 small-12">
                <h1>
                  Gymnasie&shy;portalen
                </h1>
              </div>
              <div className="column large-4 medium-4 small-12">
                <input type="text" maxLength="25" value={query} placeholder="Søg på titel ..." onChange={this.handleKeyUp} />
              </div>
            </div>
          </div>
        </div>
        <div className="column large-12 medium-12 small-12">
          <div className="gym-filter">
            <div className="row">
              {(() => {
                if (query !== '' || (assocs.length > 0)) {
                  return (
                    <div className="column large-12 medium-12 small-12">
                      <p className="result-count">
                        <strong>
                          {`${items.length} aktiviteter fundet`}
                        </strong>
                      </p>
                    </div>
                  );
                }
                return null;
              })()}
              <div className="column large-6 medium-6 small-12">
                <h4>
                  Filtrér din søgning
                </h4>
              </div>
              <div className="column large-6 medium-6 small-12">
                <button type="button" className="button float-right" onClick={this.reset}>
                  Nulstil alle filtre
                </button>
              </div>
            </div>
            <div className="row">
              {ddNodes}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchComponent.propTypes = {
  getItems: PropTypes.func.isRequired,
  groupings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // queryLength: PropTypes.number,
  setSelectedSubjects: PropTypes.func.isRequired,
};

SearchComponent.displayName = 'SearchComponent';

SearchComponent.defaultProps = {
  // queryLength: 2,
};

export default SearchComponent;
